import { LineItemsDetailView } from '@/features/LineItems/LineItemDetailView/LineItemDetailView';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const lineItemDetailSearchSchema = z.object({
    aircraftId: z.coerce.number<number>().optional(),
    workOrderId: z.coerce.number<number>().optional(),
    filter: z.string().optional(),
    tab: z.enum(['line-items', 'removal-installation']).optional(),
});

export const Route = createFileRoute('/line_items/$lineItemId/')({
    component: LineItemsDetailView,
    validateSearch: lineItemDetailSearchSchema,
});
